import api from '@/lib/api/crate-core-api-client'

export type User = {
  email: string
  username: string
  plan?: {
    id: number
    name: string
  }
  team?: {
    id: number
    name: string
    subscription?: {
      id: number
      plan?: {
        id: number
        name: string
        price: number
      }
    }
  }
  settings?: Record<string, any>
}

export const getUserProfile = async ({ signal }: { signal?: AbortSignal } = {}) => {
  const { data } = await api.get<User>('/me', { signal })
  return data
}

export const refreshToken = async (refreshToken: string, { signal }: { signal?: AbortSignal } = {}) => {
  const { data } = await api.post<{
    access_token: string
    refresh_token: string
  }>(
    '/auth/refresh-token',
    {
      refresh_token: refreshToken,
    },
    { signal }
  )
  return data
}
